import React from "react";

import { useFormikContext } from "formik";
import { ImageEngineEnum } from "../../../../../enums/imageEngine";
import { ImageSizeEnum } from "../../../../../enums/template";
import { Template } from "../../../../../models";

import InfoTooltip from "../../../../../components/common/InfoTooltip";
import RadioGroup, { Option } from "../../../../../components/form/RadioGroup";

const gptImageSizeOptions = [
  { id: ImageSizeEnum.LANDSCAPE, name: "LANDSCAPE", description: "1536x1024" },
  { id: ImageSizeEnum.PORTRAIT, name: "PORTRAIT", description: "1024x1536" },
  { id: ImageSizeEnum.SQUARE, name: "SQUARE", description: "1024x1024" },
];

const recraftImageSizeOptions = [
  { id: ImageSizeEnum.LANDSCAPE, name: "LANDSCAPE", description: "1820x1024" },
  { id: ImageSizeEnum.PORTRAIT, name: "PORTRAIT", description: "1024x1820" },
  { id: ImageSizeEnum.SQUARE, name: "SQUARE", description: "1024x1024" },
];

const geminiImageSizeOptions = [
  { id: ImageSizeEnum.LANDSCAPE, name: "LANDSCAPE", description: "16:9" },
  { id: ImageSizeEnum.PORTRAIT, name: "PORTRAIT", description: "9:16" },
  { id: ImageSizeEnum.SQUARE, name: "SQUARE", description: "1:1" },
];

export default function ImageSizeSelector() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  return (
    <div className="w-max">
      <h3 className="mb-2 tracking-wide font-medium leading-6 text-gray-900 text-xs flex items-center gap-2 uppercase">
        Image size
        <InfoTooltip
          id="imageSize"
          tooltip="This is your preferred image size. Landscape is wide, portrait is tall, and then there is square."
        />
      </h3>
      <RadioGroup
        options={
          values?.imageEngineId === ImageEngineEnum.RECRAFT_V3
            ? recraftImageSizeOptions
            : values?.imageEngineId === ImageEngineEnum.GEMINI_2_5_FLASH_IMAGE
              ? geminiImageSizeOptions
              : gptImageSizeOptions
        }
        name="imageSizeId"
        selected={values?.imageSizeId}
        onClick={({ id }: Option) => setFieldValue("imageSizeId", id)}
      />
    </div>
  );
}
